import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { buildDocumentTitle } from './page-title';

/**
 * Sets the browser tab title.
 *
 * The base title is the `<title>` from index.html. A screen adds its label with
 * the route `title` (the same text as a header menu `description`). Nested
 * submenu items pass both labels through `formatPageTitle`. A chain longer than
 * the tab limit keeps the base title and the last fragment.
 *
 * Login, signup, portal, and other pages use the same route `title`, or call
 * `setPageTitle` when the label is chosen at runtime.
 */
@Injectable()
export class PageTitleService extends TitleStrategy {
  private readonly documentTitle = inject(Title);
  private readonly baseTitle = this.documentTitle.getTitle();

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.setPageTitle(this.buildTitle(snapshot));
  }

  setPageTitle(pageTitle?: string | null): void {
    this.documentTitle.setTitle(buildDocumentTitle(this.baseTitle, pageTitle));
  }
}
